module.exports = __webpack_public_path__ + "img/all.9711749b.svg";